$(".video_section_outer").slick({
  dots: false,
  infinite: true,
  arrows: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 4000,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrows: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        centerMode:true,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        centerMode:true,
      },
    },
  ],
});
document.addEventListener("DOMContentLoaded", function () {
  var circles = document.querySelectorAll(".circle");
  var videoModal = document.getElementById("videoModal");
  var popupVideo = document.getElementById("popupVideo");
  var closeBtn = document.querySelector(".close");

  circles.forEach(function (circle) {
    circle.addEventListener("click", function () {
      var videoContainer = circle.closest(".video_section_inner-block");
      
      if (videoContainer) {
        var videoSource = videoContainer.querySelector("source");
        if (videoSource) {
          var videoSrc = videoSource.getAttribute("src");
          popupVideo.src = videoSrc;
          videoModal.style.display = "block";
        }
      }
    });
  });

  closeBtn.addEventListener("click", function () {
    videoModal.style.display = "none";
    popupVideo.pause();
  });

  window.addEventListener("click", function (event) {
    if (event.target === videoModal) {
      videoModal.style.display = "none";
      popupVideo.pause();
    }
  });
});

$(".circle").click(function () {
  $("body").addClass("active1");
});
$(".close").click(function () {
  $("body").removeClass("active1");
});